var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{attrs:{"value":_vm._f("hiddenId")(_vm.value),"disabled":_vm.disabled,"prefix-icon":"el-icon-search","placeholder":"请选择部门"},on:{"focus":_vm.onFocus}}),_c('dept-dialog',{ref:"DeptDialog",attrs:{"multi":_vm.multi},on:{"onSelect":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }